export default __webpack_public_path__ + "static/media/camera2.9fc49247.svg";